/* eslint-disable react/jsx-props-no-spreading */
import {
  GDSParagraphTextProps,
  HeadingText,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import {
  defaultHTMLTagOptions,
  HTMLTagOptions,
  isAbsoluteUrl,
} from '@leagueplatform/web-common';

export const htmlToReactOptionsOverride: HTMLTagOptions = {
  // tag comes in as h1 but design say
  h1: {
    component: (props) => <HeadingText {...props} />,
    props: {
      css: {
        // tag comes in as h1 but design say
        typography: '$headingTwo',
      },
    },
  },
  p: {
    component: (props) => <ParagraphText {...props} />,
    props: {
      css: {
        typography: '$bodyTwo',
      },
    },
  },
  span: {
    component: (props) => <ParagraphText {...props} />,
    props: {
      css: {
        typography: '$bodyTwo',
      },
    },
  },
  a: {
    component: ({ href, children, ...props }) => {
      const isExternal = isAbsoluteUrl(href);

      return (
        <a
          href={href}
          {...props}
          {...(isExternal && {
            target: '_blank',
            rel: 'noopener noreferrer',
          })}
        >
          {children}
        </a>
      );
    },
  },
};

export const RichTextSection = (props: GDSParagraphTextProps<'p'>) => (
  <ParagraphText
    htmlStringOptions={{
      ...defaultHTMLTagOptions,
      ...htmlToReactOptionsOverride,
    }}
    {...props}
  />
);
